<template>
  <div
    class="flex overflow-hidden"
    :style="`width: ${radius * 3}px; height: ${radius * 3}px;`"
    :class="[
      direction.includes('west') ? 'justify-start' : 'justify-end',
      direction.includes('north') ? 'items-start' : 'items-end',
    ]"
  >
    <div>
      <FullCircle :radius="radius" />
    </div>
  </div>
</template>

<script setup lang="ts">
import FullCircle from './FullCircle.vue'

type CardinalCompositeDirection = 'northwest' | 'northeast' | 'southwest' | 'southeast'

type Props = {
  radius?: number
  direction?: CardinalCompositeDirection
}
withDefaults(defineProps<Props>(), {
  radius: 64,
  direction: 'southeast',
})
</script>

<style></style>
